const defaultHeaders = new Headers({
  'Content-Type': 'application/json',
});

function get(url, headers=defaultHeaders) {
  return dispatch(url, 'GET', undefined, headers);
}

function head(url) {
  return dispatch(url, 'HEAD');
}

function put(url, payload) {
  return dispatch(url, 'PUT', payload, defaultHeaders);
}

function post(url, payload, headers=defaultHeaders) {
  return dispatch(url, 'POST', payload, headers);
}

function destroy(url, payload) {
  return dispatch(url, 'DELETE', payload);
}

async function dispatch(url, method, payload, headers=defaultHeaders) {
  const config = {
    method,
    headers,
    credentials: 'include',
  };
  if (payload) {
    config.body = payload;
  }
  const response = await fetch(url, config);
  if (!response.ok) {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  let data;
  if (method === 'HEAD') {
    data = response;
  } else {
    data = response.json();
  }
  return data;
}

export { get, put, post, head, destroy };



// WEBPACK FOOTER //
// ./src/utils/requests.js